import { render, staticRenderFns } from "./SntThumbImg.vue?vue&type=template&id=e26ead9a&"
import script from "./SntThumbImg.vue?vue&type=script&lang=js&"
export * from "./SntThumbImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports